(function () {
    'use strict';

    angular.module("imApp").factory("departmentLangService", ['$ihttp', function ($ihttp) {
        let service = {
            listDepartmentLang: function (parms) {
                return $ihttp.post({
                    method: 2231,
                    parameters: parms || {}
                });
            },
            saveObj: function (mergeObj) {
                return $ihttp.post({
                    method: 2232,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
